/* eslint-disable react/destructuring-assignment */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import OpcionesPago from '../../commons/ver-financiacion';
import featureAvailability from '../../commons/featureAvailability';
import common from '../../commons/commons';
import './precio.css';

const Precio = (props) => {
  const { applicationState, salidas } = props;

  // checking if country tax is apply in application country ID
  const countryTaxApply = featureAvailability.countryFeatureChecker(applicationState.paisId, countryName, 'countryTax');
  // checking if price include the new country tax
  const countryTaxIsIncluded = common.checkCountryTax(salidas[0].precios.impuestoPais);

  const titleUrl = props.title.toLowerCase().trim()
    .replace(/[-]/g, ' ')
    .replace(/[%]/g, ' ')
    .replace(/\s/g, '-')
    .replace(/[-][-][-]/g, '-')
    .replace(/[-][-]/g, '-')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/amp;/g, '');
  const ngrupo = props.salidas[0].hoteles[0] !== undefined ? props.salidas[0].hoteles[0].nroGrupo : null;
  const nroComb = props.nroComb !== undefined || props.nroComb !== null ? props.nroComb : null;
  const urlRefDetail = `${process.env.RAZZLE_URL_PATH}/viajes/${titleUrl
  }?t=${props.referencia
  }&h=${props.distribucion
  }&p=${props.proveedorId
  }&i=${props.idProducto
  }&s=${moment(props.salidas[0].fechaSalida).format('YYYY-MM-DD')
  }&m=${props.salidas[0].precios.moneda
  }&d=${props.idDestino
  }&ngrupo=${ngrupo
  }&nroComb=${nroComb
  }&origen=${props.idOrigen}`;

  function armarInfoAerolinea(transporte) {
    const elemento = '';

    if (transporte.img === 'Aerolineas Argentinas') {
      return (
        <div className='texto-transporte'>
          Viajando por:
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    if (transporte.img.length > 3) {
      return (
        <div className='padding-bottom transporte-paquete'>
          <img src={transporte.img} title={transporte.nombreTransporte} alt={transporte.nombreTransporte} className='img-responsive center-block' height='35px' width='85px' />
        </div>
      );
    }
    if (transporte.nombreTransporte.length > 1) {
      return (
        <div className='texto-transporte'>
          Viajando por:
          {' '}
          <b className='inline-block'>
            {' '}
            {transporte.nombreTransporte}
          </b>
        </div>
      );
    }
    return elemento;
  }

  function transporteElemento() {
    let img = '';
    let nombreTransporte = '';

    //Valida proveedor Allseasons
    if (props.proveedorId === 3 || props.proveedorId === 1) {
      if (props.salidas[0].transporte.transporteAereo !== null) {
        img = props.salidas[0].transporte.transporteAereo.imagen === null || props.salidas[0].transporte.transporteAereo.imagen === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.imagen;
        nombreTransporte = props.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || props.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.nombreLineaAerea;
      }
    } else {
      if (props.salidas[0].transporte.transporteAereo !== null) {
        img = props.salidas[0].transporte.transporteAereo.imagen === null || props.salidas[0].transporte.transporteAereo.imagen === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.imagen;
        nombreTransporte = props.salidas[0].transporte.transporteAereo.nombreLineaAerea === null || props.salidas[0].transporte.transporteAereo.nombreLineaAerea === undefined
          ? ''
          : props.salidas[0].transporte.transporteAereo.nombreLineaAerea;
      }
    }

    const transporte = {
      img,
      nombreTransporte,
    };
    return armarInfoAerolinea(transporte);
  }

  const currencyDefault = applicationState.currency.code;
  const precioDolar = props.salidas[0].precios.precioNetoDolares;
  return (
    <div className='row'>
      <div className='panel-precio'>
        <div className='col-md-12 col-xs-7'>
          <div className='row'>
            <div className='precio'>
              <span className='moneda'>
                {currencyDefault === 'USD' && precioDolar != null ? 'USD' : 'ARS'}
                {' '}
              </span>
              {props.precio}
            </div>
            <div className='info-precio'>
              Precio contado por persona viajando
              {' '}
              {props.cantPasajeros}
              {' '}
              personas
            </div>
            {currencyDefault === 'USD' && countryTaxIsIncluded
              ? (
                <>
                  <span className='dib included'>impuesto pais no incluido</span>
                </>
              )
              : countryTaxApply && (
                <span className='country-tax'>
                  {countryTaxIsIncluded
                    ? (
                      <>
                        <span className='dib included'>Incluye </span>
                        <span className='dib included'>30% IMPUESTO PAIS</span>
                      </>
                    )
                    : (
                      <>
                        <span className='dib not-included'>No incluye </span>
                        <span className='dib not-included'>30% IMPUESTO PAIS</span>
                      </>
                    )}
                </span>
              )}
          </div>
        </div>
        <div className='col-md-12 col-xs-5'>
          <div className='row'>
            <a className='btn paquete-detalle' href={urlRefDetail} rel='noopener noreferrer' target='_blank'> Ver Detalle</a>
            <div className='pago-cuotas-disponible'>
              <OpcionesPago
                id={props.idProducto}
                uniqueId={props.indice}
                appId={props.appId}
                price={props.precio}
                customText={(
                  <span>
                    <i className='fa fa-chevron-down' />
                    {' '}
                    Formas de pago
                  </span>
                )}
              />
            </div>
          </div>
          {transporteElemento()}
        </div>
        <div className='clearfix' />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  applicationState: state.applicationState,
  packagesDestination: state.packages.ciudadDestino,
});

export default connect(mapStateToProps, null)(Precio);
